const loadedScripts = new Set();
const initializedGtm = new Set();
const initializedGa4 = new Set();

function appendScript({ id, src, inline }) {
  if (loadedScripts.has(id) || document.getElementById(id)) return;
  const script = document.createElement("script");
  script.id = id;
  script.async = true;
  if (src) script.src = src;
  if (inline) script.text = inline;
  document.head.appendChild(script);
  loadedScripts.add(id);
}

function isEnabled(section) {
  return Boolean(section && section.enabled);
}

function loadCrisp(crisp) {
  if (!isEnabled(crisp) || !crisp.websiteId) return;
  if (window.$crisp || window.CRISP_WEBSITE_ID) return;

  window.$crisp = [];
  window.CRISP_WEBSITE_ID = crisp.websiteId;
  appendScript({
    id: "atomicpay-crisp-sdk",
    src: "https://client.crisp.chat/l.js",
  });
}

function loadGtm(gtm) {
  if (!isEnabled(gtm) || !Array.isArray(gtm.containers)) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });

  gtm.containers.forEach((container) => {
    const id = container?.id;
    if (!id || initializedGtm.has(id)) return;
    initializedGtm.add(id);
    appendScript({
      id: `atomicpay-gtm-${id}`,
      src: `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(id)}`,
    });
  });
}

function ensureGtag() {
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
  }
}

function loadGa4(ga4) {
  if (!isEnabled(ga4) || !Array.isArray(ga4.measurements)) return;
  ensureGtag();

  ga4.measurements.forEach((measurement) => {
    const id = measurement?.id;
    if (!id || initializedGa4.has(id)) return;
    initializedGa4.add(id);
    appendScript({
      id: `atomicpay-ga4-${id}`,
      src: `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`,
    });
    window.gtag("config", id, { send_page_view: false });
  });
}

export function loadCheckoutIntegrations(integrations) {
  if (!integrations || typeof window === "undefined" || typeof document === "undefined") {
    return;
  }

  loadCrisp(integrations.crisp);
  loadGtm(integrations.gtm);
  loadGa4(integrations.ga4);
}
